import styled from "styled-components";

const SatelliteImage = () => {
  return (
    <SatelliteImg>
      <img src="static/sat-img.png" alt="satellite" />
    </SatelliteImg>
  );
};

export default SatelliteImage;

const SatelliteImg = styled.section`
  /* position: absolute;
  bottom: 0;
  right: 0; */
  position: relative;
  padding-top: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    transform: scaleX(-1) rotate(-20deg);
    z-index: -1;
  }
`;
